import { combineReducers } from "@reduxjs/toolkit";
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
// Types
import Reducers from "app/types/Reducers";
// Reducers
import uiSlice from './ui/uiSlice';
import AccountsManagementReducer from './AccountsManagement/AccountsManagement.slice';
import AccountsReducer from './Accounts/Accounts.slice';
import AIChatPromptsReducer from './AIChatPrompts/AIChatPrompts.slice';
import AIChatReducer from './AIChat/AIChat.slice';
import AnalyticsReducer from './Analytics/Analytics.slice';
import AppUiDialogReducer from './AppUIDialog/AppUIDialog.slice';
import AppUINotificationsReduce from "./AppUINotifications/AppUINotifications.slice";
import AppUIStatusReducer from './AppUIStatus/AppUIStatus.slice';
import AppUiReducer from './AppUI/AppUI.slice';
import AuditReducer from './Audit/Audit.slice';
import AuthReducer from './Auth/Auth.slice';
import AutomatedWorkflowsExecutionsReducer from './AutomatedWorkflowsExecutions/AutomatedWorkflowsExecutions.slice';
import AutomatedWorkflowsReducer from './AutomatedWorkflows/AutomatedWorkflows.slice';
import BillingChargesReducer from "./BillingCharges/BillingCharges.slice";
import BillingInvoicesReducer from './BillingInvoices/BillingInvoices.slice';
import BillingOrdersReducer from './BillingOrders/BillingOrders.slice';
import BillingPackagesReducer from './BillingPackages/BillingPackages.slice';
import BillingServicesReducer from './BillingServices/BillingServices.slice';
import BillingSubscriptionsReducer from './BillingSubscriptions/BillingSubscriptions.slice';
import BillingUsageReducer from './BillingUsage/BillingUsage.slice';
import calendarSlice from './calendar/calendarSlice';
import CalendarEventsSlice from './CalendarEvents/CalendarEventsSlice';
import CalendarEventTypesSlice from './CalendarEventTypes/CalendarEventTypesSlice';
import CaseAlertsReducer from './CaseAlerts/CaseAlerts.slice';
import CaseAssignmentsReducer from './CaseAssignments/CaseAssignments.slice';
import CaseReportsReducer from './CaseReports/CaseReports.slice';
import CaseSharesReducer from './CaseShares/CaseShares.slice';
import CasesReducer from './Cases/Cases.slice';
import ClientsReducer from './Clients/Clients.slice';
import ContentReducer from './Content/Content.slice';
import ConversationsReducer from './Conversations/Conversations.slice';
import currentUserSlice from './currentUser/currentUserSlice';
import DMSBatchesReducer from './DMSBatches/DMSBatches.slice';
import DMSCollectionsReducer from "./DMSCollections/DMSCollections.slice";
import DMSDocumentPagesReducer from './DMSDocumentPages/DMSDocumentPages.slice';
import DMSDocumentsExportsReducer from "./DMSDocumentsExports/DMSDocumentsExports.slice";
import DMSDocumentsReducer from './DMSDocuments/DMSDocuments.slice';
import DMSUploadsReducer from "./DMSUploads/DMSUploads.slice";
import EpisodeAuthorsReducer from "./EpisodeAuthors/EpisodeAuthors.slice";
import EpisodeFactsReducer from './EpisodeFacts/EpisodeFacts.slice';
import EpisodesReducer from './Episodes/Episodes.slice';
import InvoicesReducer from './Invoices/Invoices.slice';
import IntegrationsReducer from "./Integrations/Integrations.slice";
import LabellingToolAnnotationsReducer from "./LabellingToolAnnotations/LabellingToolAnnotations.slice";
import LabellingToolJobsReducer from "./LabellingToolJobs/LabellingToolJobs.slice";
import MedicalRducer from './Medical/Medical.slice';
import MessagesReducer from './Messages/Messages.slice';
import PresenterReducer from './Presenter/Presenter.slice';
import ReportPresetsReducer from "./ReportPresets/ReportPresets.slice";
import RequestsReducer from "./Requests/Requests.slice";
import SettingsReducer from "./Settings/Settings.slice";
import SubscriptionsReducer from './Subscriptions/Subscriptions.slice';
import TeamsReducer from './Teams/Teams.slice';
import TemplatesReducer from './Templates/Templates.slice';
import TermsConditionsReducer from './Terms/Terms.slice';
import UsersManagementReducer from "./UsersManagement/UsersManagement.slice";
import UsersReducer from './Users/Users.slice';
import ManagerBillingUsageReducer from './ManagementBillingUsage/ManagementBillingUsage.slice';

import pagesToolbarSlice from './pagesToolbar/pagesToolbar.slice';

// Api
import CasesApi from './Cases/Cases.api';
import DMSDocumentsApi from './DMSDocuments/DMSDocuments.api';
import EpisodeAuthorsApi from './EpisodeAuthors/EpisodeAuthors.api';
// ToDO
import AppReducer from 'app/store/TODO2_app/app.reducer';
import PageReducer from 'app/store/page/page.reducer';
import OLD_AppReducer from 'app/store/TODO1_app/app.reducer';
// End ToDO

const rootReducer = (history:History) => combineReducers({
  [Reducers.Ui]: uiSlice,
  [Reducers.Accounts]: AccountsReducer,
  [Reducers.AccountsManagement]: AccountsManagementReducer,
  [Reducers.AIChat]: AIChatReducer,
  [Reducers.AIChatPrompts]: AIChatPromptsReducer,
  [Reducers.Analytics]: AnalyticsReducer,
  [Reducers.AppUi]: AppUiReducer,
  [Reducers.AppUIDialog]: AppUiDialogReducer,
  [Reducers.AppUINotifications]: AppUINotificationsReduce,
  [Reducers.AppUIStatus]: AppUIStatusReducer,
  [Reducers.Audit]: AuditReducer,
  [Reducers.Auth]: AuthReducer,
  [Reducers.AutomatedWorkflows]: AutomatedWorkflowsReducer,
  [Reducers.AutomatedWorkflowsExecutions]: AutomatedWorkflowsExecutionsReducer,
  [Reducers.BillingCharges]: BillingChargesReducer,
  [Reducers.BillingInvoices]: BillingInvoicesReducer,
  [Reducers.BillingOrders]: BillingOrdersReducer,
  [Reducers.BillingPackages]: BillingPackagesReducer,
  [Reducers.BillingServices]: BillingServicesReducer,
  [Reducers.BillingSubscriptions]: BillingSubscriptionsReducer,
  [Reducers.BillingUsage]: BillingUsageReducer,
  [Reducers.Calendar]: calendarSlice,
  [Reducers.CalendarEvents]: CalendarEventsSlice,
  [Reducers.CalendarEventTypes]: CalendarEventTypesSlice,
  [Reducers.CaseAlerts]: CaseAlertsReducer,
  [Reducers.CaseAssignments]: CaseAssignmentsReducer,
  [Reducers.CaseReports]: CaseReportsReducer,
  [Reducers.CaseShares]: CaseSharesReducer,
  [Reducers.Cases]: CasesReducer,
  [Reducers.Clients]: ClientsReducer,
  [Reducers.Conversations]: ConversationsReducer,
  [Reducers.Content]: ContentReducer,
  [Reducers.CurrentUser]: currentUserSlice,
  [Reducers.DMSBatches]: DMSBatchesReducer,
  [Reducers.DMSCollections]: DMSCollectionsReducer,
  [Reducers.DMSDocumentPages]: DMSDocumentPagesReducer,
  [Reducers.DMSDocuments]: DMSDocumentsReducer,
  [Reducers.DMSDocumentsExports]: DMSDocumentsExportsReducer,
  [Reducers.DMSUploads]: DMSUploadsReducer,
  [Reducers.EpisodeAuthors]: EpisodeAuthorsReducer,
  [Reducers.EpisodeFacts]: EpisodeFactsReducer,
  [Reducers.Episodes]: EpisodesReducer,
  [Reducers.Invoices]: InvoicesReducer,
  [Reducers.Integrations]: IntegrationsReducer,
  [Reducers.LabellingToolAnnotations]: LabellingToolAnnotationsReducer,
  [Reducers.LabellingToolJobs]: LabellingToolJobsReducer,
  [Reducers.Medical]: MedicalRducer,
  [Reducers.Messages]: MessagesReducer,
  [Reducers.Presenter]: PresenterReducer,
  [Reducers.ReportPresets]: ReportPresetsReducer,
  [Reducers.Requests]: RequestsReducer,
  [Reducers.Settings]: SettingsReducer,
  [Reducers.Subscriptions]: SubscriptionsReducer,
  [Reducers.Templates]: TemplatesReducer,
  [Reducers.Teams]: TeamsReducer,
  [Reducers.Terms]: TermsConditionsReducer,
  [Reducers.Users]: UsersReducer,
  [Reducers.UsersManagement]: UsersManagementReducer,
  [Reducers.ManagementBillingUsage]: ManagerBillingUsageReducer,
  [pagesToolbarSlice.name]: pagesToolbarSlice.reducer,

  [CasesApi.reducerPath]: CasesApi.reducer,
  [DMSDocumentsApi.reducerPath]: DMSDocumentsApi.reducer,
  [EpisodeAuthorsApi.reducerPath]: EpisodeAuthorsApi.reducer,

  // ToDO
  v3_app: AppReducer.reducer,
  app: OLD_AppReducer.reducer,
  page: PageReducer.reducer,
  router: connectRouter(history)
  // End ToDO
});

export default rootReducer;
